<div class="image_holder" [class.resize]="isFullScreen">
    <div class="circle-container">

        <ng-container *ngIf="displayLoader">
            <div class="loader">
                <div class="outer-circle"></div>
                <div class="loader-edge"></div>
                <div class="inner-circle"></div>
            </div>
        </ng-container>

        <div class="image-circle">
            <img [src]="src">
        </div>

    </div>
</div>
